import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Hand-drawn quill pen. The whole nib gently rocks left ↔ right as if it
 *  were tracing letters — a quiet ambient signal that this product is
 *  about *writing*, used as the brand accent on the home hero. */
export function IcnQuill(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const reduced = useReducedMotion();
  return (
    <Svg {...rest} iconName="quill" data-on={active ? 'true' : 'false'}>
      <g
        style={{
          transformOrigin: '13px 14px',
        }}
      >
        {/* Feather barbs along the shaft — drawn from tip → top so the
            mount draw-in feels like the pen being lifted. */}
        <path d="M3 13c2-1 3.5-3 5-5.5s3-5 5-5.5" />
        <path d="M5 11.5c1.2-0.6 2.2-1.8 3-3.4" opacity="0.55" />
        <path d="M7 9.5c0.9-0.5 1.6-1.2 2.2-2.2" opacity="0.55" />
        {/* Nib */}
        <path d="M3 13l1.6 0.4" />
        {!reduced && active && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="-2 13 14; 2 13 14; -2 13 14"
            dur="3.4s"
            repeatCount="indefinite"
          />
        )}
      </g>
    </Svg>
  );
}
